import React from 'react';
import Highlighter from 'react-highlight-words';

import { Button, renderResetCredentialsButton } from '../../../components';
import { renderRecordValue } from '../../../utils';
import { renderOrgStatus } from '../../../utils/helpers';
import { USER_ROLES, USER_STATUSES } from '../../../constants/constants';

import styles from './index.module.css';

export const renderColumns = (searchValue, highlighted) => [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 250,
    render: (text) => (
      <div className={styles.cellValue}>
        {searchValue && highlighted ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '# var(--ant-higlighter-color)', padding: 0 }}
            searchWords={[searchValue]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          renderRecordValue(text)
        )}
      </div>
    ),
  },
  {
    title: 'Users',
    dataIndex: 'usersNumber',
    key: 'usersNumber',
    render: (text) => {
      return <div className={styles.cellValue}>{renderRecordValue(text)}</div>;
    },
    width: 150,
  },
  {
    title: 'State(s)',
    dataIndex: 'state',
    key: 'state',
    render: (text) => <div className={styles.cellValue}>{renderRecordValue(text)}</div>,
    width: 270,
  },
  {
    title: 'Status',
    dataIndex: 'disabled',
    key: 'disabled',
    render: (disabled, record) => <div className={styles.cellValue}>{renderOrgStatus(disabled, record.adminStatus)}</div>,
    width: 130,
  },
  {
    title: '',
    key: 'buttons',
    dataIndex: 'buttons',
    render: (buttons) => <div className={styles.btnPanel}>{buttons.map((Component) => Component)}</div>,
    width: 680,
  },
];

export const transformData = ({
  data,
  handleManageOrganization,
  switchOrganizationStatus,
  handleSendPassword,
  handleResendInvitation,
  handleViewDashboard,
  isViewDashboardMode,
  parentHasActiveAdmin = true,
  onBlockActivation,
}) => {
  return data.map((value) => {
    let buttons;

    if (value.disabled) {
      const blockedByEnterpriseAdmin = !parentHasActiveAdmin;

      buttons = [
        <div key="activate" className={styles.restoreAccess}>
          <Button
            myClassName={styles.navigationBtn}
            onClick={blockedByEnterpriseAdmin
              ? () => onBlockActivation?.(value)
              : switchOrganizationStatus({ disabled: false, id: value.id })}>
            Activate Organization
          </Button>
        </div>,
      ];
    } else {
      const hasActiveAdmin = value.adminStatus === USER_STATUSES.ACTIVE;
      const hasResettableAdmin = Boolean(value.admin) && value.adminStatus !== USER_STATUSES.DISABLED;

      buttons = [
        ...(hasActiveAdmin ? [
          <div key="view-dashboard" className={styles.tableButton}>
            <Button
              myClassName={styles.navigationBtn}
              onClick={handleViewDashboard({
                organizationId: value.id,
                role: USER_ROLES.HO_ADMIN,
                organizationName: value.name,
                viewDashboardMode: isViewDashboardMode,
                parentOrgId: value.parentOrgId,
              })}>
              View Dashboard
            </Button>
          </div>,
        ] : []),
        ...(hasResettableAdmin ? [renderResetCredentialsButton({
          invited: value.adminStatus === USER_STATUSES.INVITED || value.adminStatus === USER_STATUSES.EXPIRED,
          handleSendPassword: handleSendPassword(value?.admin),
          handleResendInvitation: handleResendInvitation(value?.admin),
          resetButtonText: '(Send) Reset Password to Admin',
          resendButtonText: 'Resend Invitation to Admin',
        })] : []),
        <div key="manage" className={styles.tableButton}>
          <Button myClassName={styles.navigationBtn} onClick={handleManageOrganization(value.id)}>
            Manage Organization
          </Button>
        </div>,
      ];
    }

    return {
      key: value.id,
      name: value.name,
      usersNumber: value.usersNumber,
      state: value?.state,
      disabled: value.disabled,
      adminStatus: value?.adminStatus,
      buttons,
    };
  });
};
